import { LiveBookingSuggestions } from "@eljouren/domain";
import ClientUtils from "../../../utils/ClientUtils";

import { useMemo, useState } from "react";
import withSalesCredentials from "../../../components/auth/hocs/withSalesCredentials";
import AppTextButton from "../../../components/common/buttons/AppTextButton";
import AppPage from "../../../components/layout/AppPage";
import BookingSuggestionsResultsView from "./results/BookingSuggestionsResultsView";
import SalesTeamBookingSuggestionsForm from "./form/SalesTeamBookingSuggestionsForm";
import { SimplifiedBookingSuggestions } from "../../../_model/repos/BookingSuggestionsApiClient";
import SimplifiedBookingSuggestionsResultsView from "./results/SimplifiedBookingSuggestionsResultsView";
import { useParams } from "react-router-dom";
import { z } from "@ipis/centralized-zod";

const Country = z.enum(["Sweden", "Norway"])
type TCountry = z.infer<typeof Country>;

export type BookingSuggestionsResult =
  | {
    type: "original";
    suggestions: LiveBookingSuggestions.Type;
  }
  | {
    type: "simplified";
    suggestions: SimplifiedBookingSuggestions;
  };

enum Tab {
  form,
  result,
}

const SalesTeamBookingSuggestionsRoute = () => {
  const [result, setResult] = useState<BookingSuggestionsResult | null>(null);
  const [_tab, setTab] = useState<Tab>(Tab.form);
  const tab = result ? _tab : Tab.form;

  const { country: countryParam } = useParams();

  const country = useMemo((): TCountry => {
    if (countryParam === "norway") {
      return "Norway";
    }

    return "Sweden";
  }, [countryParam])



  function onBookingSuggestionsReturned(result: BookingSuggestionsResult) {
    setResult(result);
    setTab(Tab.result);
  }

  return (
    <AppPage
      headerProps={{
        heading: "Hitta bokningsförslag",
      }}
      className="w-full p-8"
    >
      <section className="grid grid-cols-1 grid-rows-[auto,minmax(0,1fr)] gap-4 overflow-auto 3xl:grid-cols-[0.8fr,1.2fr] 3xl:grid-rows-1 3xl:gap-16">
        <header className="flex items-center gap-4 3xl:hidden">
          <AppTextButton
            onClick={() => setTab(Tab.form)}
            className={ClientUtils.classNames(tab === Tab.form && "underline")}
          >
            Sök
          </AppTextButton>
          <AppTextButton
            disabled={!result}
            onClick={() => setTab(Tab.result)}
            className={ClientUtils.classNames(
              tab === Tab.result && "underline"
            )}
          >
            Resultat
          </AppTextButton>
        </header>
        <section
          className={ClientUtils.classNames(
            "h-full w-full max-w-screen-md grid-cols-1 grid-rows-1 3xl:max-w-none",
            result && "grid-rows-[auto,minmax(0,1fr)]",
            tab !== Tab.form && "hidden 3xl:grid",
            tab === Tab.form && "grid"
          )}
        >
          <SalesTeamBookingSuggestionsForm
            onBookingSuggestionsReturned={onBookingSuggestionsReturned}
            country={country}
          />
        </section>
        <section
          className={ClientUtils.classNames(
            "h-full w-full max-w-screen-4xl grid-cols-1 grid-rows-1 3xl:max-w-none",
            tab !== Tab.result && "hidden 3xl:grid",
            tab === Tab.result && "grid"
          )}
        >
          {result && result.type === "original" && (
            <BookingSuggestionsResultsView suggestions={result.suggestions} />
          )}
          {result && result.type === "simplified" && (
            <SimplifiedBookingSuggestionsResultsView
              suggestions={result.suggestions}
            />
          )}
        </section>
      </section>
    </AppPage>
  );
};

export default withSalesCredentials(SalesTeamBookingSuggestionsRoute);
